export default {
  default: () => import("/var/jenkins_home/workspace/nearhub-websites-bundle/nearhub-website/layouts/default.vue"),
  empty: () => import("/var/jenkins_home/workspace/nearhub-websites-bundle/nearhub-website/layouts/empty.vue")
}